import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_garden_bbq: FaireCategoryEntity = {
  token: "cat_garden-bbq",
  type: "category",
  name: "BBQ accessories",
  level: 3,
  parentToken: "cat_home-decor-garden",
  href: "/category/home-decor/garden-outdoor/bbq-accessories",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
